import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {
    EventContainerMovementTargetUserOuMembership,
    type EventContainerMovementOperationConfiguration,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/eventContainerMovementWorkspaceCapability/domain/EventContainerMovementWorkspaceCapabilityConfiguration";
import type {EventContainerTemplate} from "~/domainModels/workspaceModules/eventContainersModule";

export type MovementTemplate = Pick<EventContainerTemplate, "id" | "configuration">;

export function getTransferOrganizationalUnitColumnId(templates: ReadonlyArray<MovementTemplate>, templateId: Uuid): Uuid | null {
    const template = templates.find((candidate) => candidate.id === templateId);
    if (template === undefined) {
        throw new Error(`Event Container template not found: ${templateId}`);
    }
    return template.configuration.organizationalUnitColumnConfig?.columnId ?? null;
}

/** Geography is business data, never an OU movement field. */
export function isMovementCombinationSupported(
    operation: EventContainerMovementOperationConfiguration,
    combination: ReadonlyArray<Uuid>,
    templates: ReadonlyArray<MovementTemplate>,
): boolean {
    const template = templates.find((candidate) => candidate.id === operation.eventContainerTemplateId);
    if (template === undefined) {
        return false;
    }
    const ouColumn = template.configuration.organizationalUnitColumnConfig?.columnId ?? null;
    const nonAssignmentFields = combination.filter((field) => !operation.assignmentColumnIds.includes(field));
    if (ouColumn === null) {
        return (
            nonAssignmentFields.length === 0 &&
            operation.targetUserEligibility.organizationalUnitMembership === EventContainerMovementTargetUserOuMembership.notRequired
        );
    }
    return nonAssignmentFields.length === 0 || (operation.organizationalUnit !== undefined && nonAssignmentFields.every((field) => field === ouColumn));
}
